module.exports = __webpack_public_path__ + "img/lock.2151b64c.svg";